export const FINANCE_PROGRESS_STATUS = {
  ACCEPTED: 0,
  IN_PROGRESS: 1,
  APPROVED: 2,
  DENIED: 3,
  RETURNED: 4,
  WAITING_FOR_CONFIRM: 5,
  TEMPLATE: 6,
  CLOSED: 7,
};

export const FINANCIAL_DOCUMENT_TYPE = {
  RECEIVED_INVOICE: 1,   // Faktura prijata
  ISSUED_INVOICE: 2,     // Faktura vydana ???
  ADVANCED_INVOICE: 3,   // Faktura zalohova
  RECEIVED_ORDER: 4,     // Objednavka prijata ???
  ISSUED_ORDER: 5,       // Objednavka vydana
  CONTRACT: 6,           // Smlouva
  PURCHASE_INTENT: 7,    // Zamer
  PUBLIC_PROCUREMENT: 8, // Verejna zakazka
};

export const BUDGET_TYPE = {
  OBLAST: 0,
  KOMISE: 1,
  URAD: 2,
  HSCELKOVY: 3,
  BIH: 4,
};

export const INVOICE_LINK_TYPE = {
  NONE: 0,
  ORDER: 1,
  CONTRACT: 2,
  WITHOUT_LINK: 3,
};

export const INVOICE_TYPE = {
  NORMAL: 1, // normální
  ADVANCE: 3, // zálohová
  // CREDIT_NOTE: 3, // dobropis
  // INTENTIONS: 4, // záměry
};

export const PAYMENT_TYPE = {
  BANK_TRANSFER: 1,   //Bankovním převodem
  CASH: 2,            //Hotově
  SET_OFF: 3,         //Zápočtem
  CARD: 4,            //Platební kartou
  ADVANCE_DEPOSIT: 5, //Zálohou
  DIRECT_DEBIT: 6,    //Inkasem
  };
export const BANK_PAYMENT_STATUS = {
  Pending: {
    label: "Čeká na zpracování",
    color: "warning",
  },
  Executed: {
    label: "Provedeno",
    color: "success",
  },
  Rejected: {
    label: "Zamítnuto",
    color: "danger",
  },
};

export const getCurrencyFormatter = (currencyCode, currencySymbol) => {
  const nf = new Intl.NumberFormat("cs-CZ", {
    style: "currency",
    currency: currencyCode,
    currencyDisplay: "symbol",
  });

  // Bezpečné defaulty pro pár běžných měn
  const SYMBOL_OVERRIDES = {
    CZK: "Kč",
    EUR: "€",
    USD: "$",
    GBP: "£",
    PLN: "zł",
    HUF: "Ft",
    CHF: "₣",
  };

  const override = currencySymbol ?? SYMBOL_OVERRIDES[currencyCode];

  return {
    format(value) {
      const parts = nf.formatToParts(value);
      // Přepíšeme pouze část typu 'currency', zbytek (oddělovače, mezery, pořadí) zůstane z cs-CZ
      return parts
        .map(p => (p.type === "currency" && override ? override : p.value))
        .join("");
    },
  };
};
